import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, vModelText as _vModelText, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, vModelSelect as _vModelSelect } from "vue"

const _hoisted_1 = /*#__PURE__*/_createElementVNode("div", { class: "view__header" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "view__header_title" }, "Агенты")
], -1)
const _hoisted_2 = { class: "view-table box" }
const _hoisted_3 = { class: "view-table__header" }
const _hoisted_4 = { class: "view-table__description" }
const _hoisted_5 = { class: "view-table__pagination" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("span", null, "Страница", -1)
const _hoisted_7 = ["max"]
const _hoisted_8 = /*#__PURE__*/_createElementVNode("span", null, "из", -1)
const _hoisted_9 = {
  key: 0,
  class: "table is-bordered"
}
const _hoisted_10 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"200px"} }, "ФИО"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Дата регистрации"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Телефон"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Почта"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Реф. ссылка"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Промокод"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Паспорт"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Статус"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Выведено"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Доступно"),
    /*#__PURE__*/_createElementVNode("th", { style: {"min-width":"100px"} }, "Запрошено")
  ])
], -1)
const _hoisted_11 = {
  key: 1,
  class: "table-container__empty"
}
const _hoisted_12 = {
  key: 0,
  class: "view-table_options"
}
const _hoisted_13 = { class: "view-table_options__content box is-radiusless" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Поиск", -1)
const _hoisted_15 = { class: "field has-addons" }
const _hoisted_16 = { class: "control" }
const _hoisted_17 = { class: "select" }
const _hoisted_18 = ["value"]
const _hoisted_19 = { class: "control is-expanded has-icons-right" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-times" }, null, -1)
const _hoisted_21 = [
  _hoisted_20
]
const _hoisted_22 = { class: "field" }
const _hoisted_23 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Статус агента", -1)
const _hoisted_24 = { class: "control" }
const _hoisted_25 = { class: "select" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "-", -1)
const _hoisted_27 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Активен", -1)
const _hoisted_28 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Заблокирован", -1)
const _hoisted_29 = [
  _hoisted_26,
  _hoisted_27,
  _hoisted_28
]
const _hoisted_30 = { class: "field" }
const _hoisted_31 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Статус паспорта", -1)
const _hoisted_32 = { class: "control" }
const _hoisted_33 = { class: "select" }
const _hoisted_34 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "-", -1)
const _hoisted_35 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Подтвержден", -1)
const _hoisted_36 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Не подтвержден", -1)
const _hoisted_37 = [
  _hoisted_34,
  _hoisted_35,
  _hoisted_36
]
const _hoisted_38 = { class: "field" }
const _hoisted_39 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Роль", -1)
const _hoisted_40 = { class: "control" }
const _hoisted_41 = { class: "select" }
const _hoisted_42 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "-", -1)
const _hoisted_43 = ["value"]
const _hoisted_44 = { class: "field" }
const _hoisted_45 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Наблюдаемый", -1)
const _hoisted_46 = { class: "control" }
const _hoisted_47 = { class: "select" }
const _hoisted_48 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "-", -1)
const _hoisted_49 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Да", -1)
const _hoisted_50 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Нет", -1)
const _hoisted_51 = [
  _hoisted_48,
  _hoisted_49,
  _hoisted_50
]
const _hoisted_52 = { class: "field" }
const _hoisted_53 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Сотрудник", -1)
const _hoisted_54 = { class: "control" }
const _hoisted_55 = { class: "select" }
const _hoisted_56 = /*#__PURE__*/_createElementVNode("option", { value: "" }, "-", -1)
const _hoisted_57 = /*#__PURE__*/_createElementVNode("option", { value: "1" }, "Да", -1)
const _hoisted_58 = /*#__PURE__*/_createElementVNode("option", { value: "0" }, "Нет", -1)
const _hoisted_59 = [
  _hoisted_56,
  _hoisted_57,
  _hoisted_58
]
const _hoisted_60 = { class: "field mt-auto" }
const _hoisted_61 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Показывать по", -1)
const _hoisted_62 = { class: "control" }
const _hoisted_63 = { class: "select" }
const _hoisted_64 = ["value"]
const _hoisted_65 = { class: "field" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("label", { class: "label" }, "Сортировка", -1)
const _hoisted_67 = { class: "control" }
const _hoisted_68 = { class: "select" }
const _hoisted_69 = ["value"]
const _hoisted_70 = { class: "view-table_options__actions" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _hoisted_1,
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("span", _hoisted_4, "Всего найдено " + _toDisplayString(_ctx.ctx.meta.total), 1),
        _createElementVNode("div", _hoisted_5, [
          _hoisted_6,
          _withDirectives(_createElementVNode("input", {
            class: "input",
            type: "number",
            min: "1",
            max: _ctx.ctx.meta.page.total,
            "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.page) = $event)),
            onChange: _cache[1] || (_cache[1] = ($event: any) => (_ctx.changePage()))
          }, null, 40, _hoisted_7), [
            [_vModelText, _ctx.page]
          ]),
          _hoisted_8,
          _createElementVNode("span", null, _toDisplayString(_ctx.ctx.meta.page.total), 1)
        ]),
        _createElementVNode("button", {
          class: "button is-info",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (_ctx.showOptions = true))
        }, "Опции")
      ]),
      _createElementVNode("div", {
        class: _normalizeClass(["table-container with-scrollbar", {'busy':_ctx.ctx.isLoading, 'lock': _ctx.showOptions}]),
        id: "table"
      }, [
        (_ctx.ctx.list.length)
          ? (_openBlock(), _createElementBlock("table", _hoisted_9, [
              _hoisted_10,
              _createElementVNode("tbody", null, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.list, (item) => {
                  return (_openBlock(), _createElementBlock("tr", {
                    key: item.id
                  }, [
                    _createElementVNode("td", null, [
                      _createVNode(_component_router_link, {
                        to: { name: 'AgentsCard', params: { agent: item.general.id } }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(item.passport.fullname), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("td", null, _toDisplayString(item.general.registration_date), 1),
                    _createElementVNode("td", null, _toDisplayString(item.mlm.phone), 1),
                    _createElementVNode("td", null, _toDisplayString(item.general.email), 1),
                    _createElementVNode("td", null, _toDisplayString(item.mlm.refurl), 1),
                    _createElementVNode("td", null, _toDisplayString(item.mlm.promocode), 1),
                    _createElementVNode("td", null, _toDisplayString(item.passport.is_passport_verified ? "Подтвержден" : "Нет"), 1),
                    _createElementVNode("td", null, _toDisplayString(item.general.is_banned ? "Заблокирован" : "Активен"), 1),
                    _createElementVNode("td", null, _toDisplayString(item.statistic.orders_paid.total), 1),
                    _createElementVNode("td", null, _toDisplayString(item.statistic.balance.current), 1),
                    _createElementVNode("td", null, _toDisplayString(item.statistic.orders.requested), 1)
                  ]))
                }), 128))
              ])
            ]))
          : (_openBlock(), _createElementBlock("span", _hoisted_11, "Пусто"))
      ], 2)
    ]),
    (_ctx.showOptions)
      ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
          _createElementVNode("div", {
            class: "view-table_options__overlay",
            onClick: _cache[3] || (_cache[3] = 
//@ts-ignore
(...args) => (_ctx.close && _ctx.close(...args)))
          }),
          _createElementVNode("div", _hoisted_13, [
            _hoisted_14,
            _createElementVNode("div", _hoisted_15, [
              _createElementVNode("p", _hoisted_16, [
                _createElementVNode("span", _hoisted_17, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_ctx.search) = $event)),
                    onChange: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.changeSearch && _ctx.changeSearch(...args)))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.searchVariants, (s) => {
                      return (_openBlock(), _createElementBlock("option", { value: s }, _toDisplayString(s.name), 9, _hoisted_18))
                    }), 256))
                  ], 544), [
                    [_vModelSelect, _ctx.search]
                  ])
                ])
              ]),
              _createElementVNode("p", _hoisted_19, [
                (_ctx.search.param === 'search_fio')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 0,
                      class: "input",
                      onType: _cache[6] || (_cache[6] = 
//@ts-ignore
(...args) => (_ctx.text && _ctx.text(...args))),
                      "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((_ctx.searchFIO) = $event))
                    }, null, 544)), [
                      [_vModelText, _ctx.searchFIO]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.search.param === 'search_email')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 1,
                      class: "input",
                      onType: _cache[8] || (_cache[8] = 
//@ts-ignore
(...args) => (_ctx.text && _ctx.text(...args))),
                      "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((_ctx.searchEmail) = $event))
                    }, null, 544)), [
                      [_vModelText, _ctx.searchEmail]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.search.param === 'search_ref')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 2,
                      class: "input",
                      onType: _cache[10] || (_cache[10] = 
//@ts-ignore
(...args) => (_ctx.text && _ctx.text(...args))),
                      "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_ctx.searchRef) = $event))
                    }, null, 544)), [
                      [_vModelText, _ctx.searchRef]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.search.param === 'search_promo')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 3,
                      class: "input",
                      onType: _cache[12] || (_cache[12] = 
//@ts-ignore
(...args) => (_ctx.text && _ctx.text(...args))),
                      "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_ctx.searchPromo) = $event))
                    }, null, 544)), [
                      [_vModelText, _ctx.searchPromo]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.search.param === 'search_phone')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 4,
                      class: "input",
                      onType: _cache[14] || (_cache[14] = 
//@ts-ignore
(...args) => (_ctx.text && _ctx.text(...args))),
                      "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_ctx.searchPhone) = $event))
                    }, null, 544)), [
                      [_vModelText, _ctx.searchPhone]
                    ])
                  : _createCommentVNode("", true),
                (_ctx.search.param === 'search_inn')
                  ? _withDirectives((_openBlock(), _createElementBlock("input", {
                      key: 5,
                      class: "input",
                      onType: _cache[16] || (_cache[16] = 
//@ts-ignore
(...args) => (_ctx.text && _ctx.text(...args))),
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((_ctx.searchInn) = $event))
                    }, null, 544)), [
                      [_vModelText, _ctx.searchInn]
                    ])
                  : _createCommentVNode("", true),
                _createElementVNode("span", {
                  class: "icon is-right is-clickable clear-field-icon has-text-dark",
                  onClick: _cache[18] || (_cache[18] = 
//@ts-ignore
(...args) => (_ctx.changeSearch && _ctx.changeSearch(...args)))
                }, _hoisted_21)
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _hoisted_23,
              _createElementVNode("p", _hoisted_24, [
                _createElementVNode("span", _hoisted_25, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => ((_ctx.filterBanned) = $event))
                  }, _hoisted_29, 512), [
                    [_vModelSelect, _ctx.filterBanned]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_30, [
              _hoisted_31,
              _createElementVNode("p", _hoisted_32, [
                _createElementVNode("span", _hoisted_33, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => ((_ctx.filterPassportVerified) = $event))
                  }, _hoisted_37, 512), [
                    [_vModelSelect, _ctx.filterPassportVerified]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_38, [
              _hoisted_39,
              _createElementVNode("p", _hoisted_40, [
                _createElementVNode("span", _hoisted_41, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => ((_ctx.filterRoleId) = $event))
                  }, [
                    _hoisted_42,
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.roles, (role) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: role.id
                      }, _toDisplayString(role.name), 9, _hoisted_43))
                    }), 256))
                  ], 512), [
                    [_vModelSelect, _ctx.filterRoleId]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_44, [
              _hoisted_45,
              _createElementVNode("p", _hoisted_46, [
                _createElementVNode("span", _hoisted_47, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => ((_ctx.filterIsWatched) = $event))
                  }, _hoisted_51, 512), [
                    [_vModelSelect, _ctx.filterIsWatched]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_52, [
              _hoisted_53,
              _createElementVNode("p", _hoisted_54, [
                _createElementVNode("span", _hoisted_55, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => ((_ctx.filterIsEmployer) = $event))
                  }, _hoisted_59, 512), [
                    [_vModelSelect, _ctx.filterIsEmployer]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_60, [
              _hoisted_61,
              _createElementVNode("p", _hoisted_62, [
                _createElementVNode("span", _hoisted_63, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => ((_ctx.limit) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.LimitPageVariants, (variant) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: variant.value,
                        key: variant.name
                      }, _toDisplayString(variant.name), 9, _hoisted_64))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.limit]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_65, [
              _hoisted_66,
              _createElementVNode("p", _hoisted_67, [
                _createElementVNode("span", _hoisted_68, [
                  _withDirectives(_createElementVNode("select", {
                    "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => ((_ctx.sorting) = $event))
                  }, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.ctx.sortingVariants, (variant) => {
                      return (_openBlock(), _createElementBlock("option", {
                        value: variant,
                        key: variant.name
                      }, _toDisplayString(variant.name), 9, _hoisted_69))
                    }), 128))
                  ], 512), [
                    [_vModelSelect, _ctx.sorting]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("button", {
                class: "button is-primary",
                onClick: _cache[26] || (_cache[26] = 
//@ts-ignore
(...args) => (_ctx.apply && _ctx.apply(...args)))
              }, "Применить"),
              _createElementVNode("button", {
                class: "button is-ghost",
                onClick: _cache[27] || (_cache[27] = 
//@ts-ignore
(...args) => (_ctx.clear && _ctx.clear(...args)))
              }, "Сбросить"),
              _createElementVNode("button", {
                class: "button is-light",
                onClick: _cache[28] || (_cache[28] = 
//@ts-ignore
(...args) => (_ctx.cancel && _ctx.cancel(...args)))
              }, "Отмена")
            ])
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}